import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const pause = (duration) => {
  return new Promise((resolve) => setTimeout(resolve, duration));
};

const departmentApi = createApi({
  reducerPath: "department",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_ENDPOINT}api`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("access-token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    },
    fetchFn: async (...args) => {
      await pause(1000);
      return fetch(...args);
    },
  }),
  endpoints(builder) {
    return {
      fetchDepartments: builder.query({
        providesTags: (result, error, arg) => ["departments"],
        query: () => {
          return {
            url: "department/",
            method: "GET",
          };
        },
      }),
      fetchDepartment: builder.query({
        providesTags: (result, error, arg) => ["department"],
        query: (id) => {
          return {
            url: `department/${id}`,
            method: "GET",
          };
        },
      }),
      postDepartment: builder.mutation({
        query: (body) => {
          return {
            url: "department/",
            method: body.id === 0 ? "POST" : "PUT",
            body,
          };
        },
        invalidatesTags: ["departments", "department"],
      }),
      putDepartment: builder.mutation({
        query: (body) => {
          return {
            url: "department/",
            method: "PUT",
            body,
          };
        },
        invalidatesTags: ["departments", "department"],
      }),
      deleteDepartment: builder.mutation({
        query: (id) => {
          return {
            url: `department/${id}`,
            method: "DELETE",
          };
        },
        invalidatesTags: ["departments", "department"],
      }),
    };
  },
});

export const {
  useFetchDepartmentsQuery,
  usePostDepartmentMutation,
  usePutDepartmentMutation,
  useDeleteDepartmentMutation,
  useFetchDepartmentQuery,
} = departmentApi;
export { departmentApi };
